<div class="card-header">
  <app-breadcrumb currentPage="contact"></app-breadcrumb>
</div>
<div class="card-body">
  <p class="mb28">heeft u een vraag en/of opmerking, neem dan contact met ons op via het onderstaande formulier of
    stuur een mail naar <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>.</p>

  <form class="form" [formGroup]="form" (ngSubmit)="save(form.value)">
    <label class="form-label" for="name">naam *</label>
    <input id="name" formControlName="name" type="text"
           [ngClass]="{ 'input-error': submitted && f.name.errors }">
    <div *ngIf="submitted && f.name.errors">
      <div *ngIf="f.name.errors.required">naam bewindvoerder is verplicht.</div>
    </div>


    <label class="form-label" for="mail">e-mailadres *</label>
    <input id="mail" formControlName="mail" type="text"
           [ngClass]="{ 'input-error': submitted && f.mail.errors }">
    <div *ngIf="submitted && f.mail.errors">
      <div *ngIf="f.mail.errors.required">e-mailadres bewindvoerder is verplicht.</div>
      <div *ngIf="f.mail.errors.pattern">e-mailadres bewindvoerder is geen geldig e-mailadres.</div>
    </div>

    <label class="form-label" for="phone">mobiel</label>
    <input id="phone" formControlName="phone" type="text"
           [ngClass]="{ 'input-error': submitted && f.phone.errors }">

    <label class="form-label" for="question">vraag of opmerking</label>
    <textarea id="question" formControlName="question" type="text"
              [ngClass]="{ 'input-error': submitted && f.question.errors }" style="min-height: 150px;"></textarea>
    <div *ngIf="submitted && f.question.errors">
      <div *ngIf="f.question.errors.required">vraag of opmerking is verplicht.</div>
    </div>

    <div class="spacer-small"></div>
    <button class="btn plus btn-left" type="submit">Verstuur</button>

    <div class="spacer-small"></div>
  </form>
  Ter kennismaking geldt dat alle rapportages die u in 2020 maakt zonder kosten kunnen worden gegenereerd en
  geproduceerd. In ruil daarvoor ontvangen we graag uw feedback omdat we onze software-oplossingen altijd beter willen
  maken.
</div>
